module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.orderList) ? _c('div', [_vm._l((_vm.orderList), function(order, index) {
    return (_vm.sessionInfo.customerInfo.ssoFlag === 0) ? _c('div', {
      staticClass: "list-block media-list",
      staticStyle: {
        "margin-bottom": "3rem"
      }
    }, [_c('ul', [(order.merchandises) ? _c('li', [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "border-bottom": "3px solid ghostwhite"
      }
    }, [(order.selfOperated === 0) ? _c('span', {
      staticStyle: {
        "color": "black",
        "font-size": "0.7rem",
        "margin-left": "0.2rem"
      }
    }, [_vm._v("第三方")]) : _vm._e(), _vm._v(" "), (order.selfOperated === 1) ? _c('span', {
      staticStyle: {
        "color": "black",
        "font-size": "0.7rem",
        "margin-left": "0.2rem"
      }
    }, [_vm._v("吉凯基因")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "gray",
        "font-size": "0.8rem",
        "float": "right"
      }
    }, [_vm._v(_vm._s(order.status === 2 && order.researchGroupApproveResult === _vm.waitApproveStatus ? '待审批' : _vm.description))])]), _vm._v(" "), (order.subOrders.length === 0) ? _c('router-link', {
      staticClass: "item-link item-content",
      attrs: {
        "to": {
          name: 'myOrderDetail',
          query: {
            BOrder: JSON.stringify(order)
          }
        }
      }
    }, [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "border-bottom": "1px solid gray"
      }
    }, [_c('div', {
      staticClass: "item-media"
    }, _vm._l((order.merchandises), function(merchandise) {
      return _c('div', [_c('img', {
        staticStyle: {
          "width": "4rem",
          "margin-left": "0.1rem"
        },
        attrs: {
          "src": _vm.baseurl + merchandise.merchandiseDetailForClient.merchandiseIcon
        }
      }), _vm._v(" "), (merchandise.merchandiseDetailForClient.categoryId === 10) ? _c('div', {
        staticStyle: {
          "font-size": ".2rem",
          "text-align": "center"
        }
      }, [(merchandise._titleList[0].valueText !== '-1' && merchandise._titleList[0].valueText) ? _c('span', [_vm._v(_vm._s(merchandise._titleList[0].valueText))]) : _vm._e(), _vm._v(" "), (merchandise._titleList[1] && merchandise._titleList[1].valueText && merchandise._titleList[1].valueText !== '-1') ? _c('span', [_vm._v(_vm._s(merchandise._titleList[1].valueText))]) : _vm._e()]) : _c('div', {
        staticStyle: {
          "font-size": ".2rem",
          "text-align": "center"
        }
      }, [(merchandise._titleList[0].valueText !== '-1') ? _c('span', [_vm._v(_vm._s(merchandise._titleList[0].valueText))]) : _vm._e()])])
    }), 0)])]) : _vm._e(), _vm._v(" "), _vm._l((order.subOrders), function(suborder) {
      return (order.subOrders.length > 0) ? _c('div', [_c('router-link', {
        staticClass: "item-link item-content",
        attrs: {
          "to": {
            name: 'myOrderDetail',
            query: {
              BOrder: JSON.stringify(order)
            }
          }
        }
      }, [_c('div', {
        staticClass: "item-inner",
        staticStyle: {
          "border-bottom": "1px solid gray"
        }
      }, [_c('div', {
        staticClass: "item-media"
      }, _vm._l((suborder.merchandises), function(merch) {
        return _c('div', [_c('img', {
          staticStyle: {
            "width": "4rem",
            "margin-left": "0.2rem"
          },
          attrs: {
            "src": _vm.baseurl + merch.merchandiseDetailForClient.merchandiseIcon
          }
        }), _vm._v(" "), (merch.merchandiseDetailForClient.categoryId === 10) ? _c('div', {
          staticStyle: {
            "font-size": ".2rem",
            "text-align": "center"
          }
        }, [(merch._titleList[0].valueText !== '-1') ? _c('span', [_vm._v(_vm._s(merch._titleList[0].valueText) + "}")]) : _vm._e(), _vm._v(" "), (merch._titleList[1].valueText !== '-1') ? _c('span', [_vm._v(_vm._s(merch._titleList[1].valueText))]) : _vm._e()]) : _c('div', {
          staticStyle: {
            "font-size": ".2rem",
            "text-align": "center"
          }
        }, [(merch._titleList[0].valueText !== '-1') ? _c('span', [_vm._v("\n                    " + _vm._s(merch._titleList[0].valueText) + "  ")]) : _vm._e()]), _vm._v(" "), (merch && merch.selfOperated === 0) ? _c('div', {
          staticStyle: {
            "margin-top": "10px"
          }
        }, [_c('span', {
          staticStyle: {
            "font-size": "x-small",
            "color": "#1482E7"
          }
        }, [_vm._v("【第三方】")])]) : _vm._e()])
      }), 0)])])], 1) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [(order.isStock) ? _c('div', {
      staticStyle: {
        "color": "black",
        "font-size": "0.7rem",
        "text-align": "right"
      }
    }, [_vm._v("\n            共" + _vm._s(order.productNum) + "个商品 "), _c('span', {
      staticStyle: {
        "margin-left": "1rem"
      }
    }, [_vm._v(" 实支付：")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "1.2rem"
      }
    }, [_vm._v(_vm._s(_vm._f("currencyStyle")(order.totalPrice)))])]) : _vm._e(), _vm._v(" "), (order.isStock === false) ? _c('div', {
      staticStyle: {
        "color": "black",
        "font-size": "0.7rem",
        "text-align": "right"
      }
    }, [_vm._v("\n            共" + _vm._s(order.productNum) + "个商品 "), _c('span', {
      staticStyle: {
        "margin-left": "1rem"
      }
    }, [_vm._v(" 实支付：")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "1.2rem"
      }
    }, [_vm._v(_vm._s(_vm._f("currencyStyle")(order.totalPrice)))])]) : _vm._e()]), _vm._v(" "), _c('div', [(order.status === 11 && order.merchandises[0].categoryId === 20 && (order.merchandises[0]._attributes.ReguTech === undefined || order.merchandises[0]._attributes.ReguTech.value !== '5')) ? _c('span', {
      staticClass: "orderBtn",
      staticStyle: {
        "color": "white",
        "background": "rgb(0, 70, 154)"
      },
      on: {
        "click": function($event) {
          return _vm.buyAgain1(order)
        }
      }
    }, [_vm._v("我要扩增")]) : _vm._e(), _vm._v(" "), (order.status === 2 || 3) ? _c('span', {
      staticClass: "orderBtn",
      on: {
        "click": function($event) {
          return _vm.response1(order)
        }
      }
    }, [_c('img', {
      staticClass: "position",
      attrs: {
        "src": _vm.button1Name
      }
    })]) : _vm._e(), _vm._v(" "), (order.researchGroupApproveResult !== _vm.waitApproveStatus) ? _c('span', {
      staticClass: "orderBtn",
      on: {
        "click": function($event) {
          return _vm.response2(order)
        }
      }
    }, [_c('img', {
      staticClass: "pay-btn",
      attrs: {
        "src": _vm.button2Name
      }
    })]) : _vm._e()])], 2) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.orderList), function(order, index) {
    return (_vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('div', {
      staticClass: "list-block media-list",
      staticStyle: {
        "margin-bottom": "3rem"
      }
    }, [_c('ul', [(order.merchandises) ? _c('li', [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "border-bottom": "1px solid gray"
      }
    }, _vm._l((order.merchandises), function(merchandise) {
      return _c('div', [_c('a', {
        on: {
          "click": function($event) {
            return _vm.response3(merchandise)
          }
        }
      }, [_c('div', [_c('img', {
        staticStyle: {
          "width": "4rem",
          "margin-left": "0.1rem"
        },
        attrs: {
          "src": _vm.baseurl + merchandise.merchandiseDetailForClient.merchandiseIcon
        }
      }), _vm._v(" "), (merchandise.merchandiseDetailForClient.categoryId === 10) ? _c('div', {
        staticStyle: {
          "font-size": ".2rem",
          "margin-left": "0.1rem",
          "color": "black"
        }
      }, [(merchandise._titleList[0].valueText !== '-1' && merchandise._titleList[0].valueText) ? _c('span', [_vm._v(_vm._s(merchandise._titleList[0].valueText))]) : _vm._e(), _vm._v(" "), (merchandise._titleList[1] && merchandise._titleList[1].valueText && merchandise._titleList[1].valueText !== '-1') ? _c('span', [_vm._v(_vm._s(merchandise._titleList[1].valueText))]) : _vm._e()]) : _c('div', {
        staticStyle: {
          "font-size": ".2rem",
          "margin-left": "1rem",
          "color": "black"
        }
      }, [(merchandise._titleList[0].valueText !== '-1') ? _c('span', [_vm._v(_vm._s(merchandise._titleList[0].valueText))]) : _vm._e()])])])])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [(order.isStock) ? _c('div', {
      staticStyle: {
        "color": "black",
        "font-size": "0.7rem",
        "text-align": "right"
      }
    }, [_vm._v("\n            共" + _vm._s(order.productNum) + "个商品 "), _c('span', {
      staticStyle: {
        "margin-left": "1rem"
      }
    }, [_vm._v(" 实支付：")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "1.2rem"
      }
    }, [_vm._v(_vm._s(_vm._f("currencyStyle")(order.totalPrice)))])]) : _vm._e(), _vm._v(" "), (order.isStock === false) ? _c('div', {
      staticStyle: {
        "color": "black",
        "font-size": "0.7rem",
        "text-align": "right"
      }
    }, [_vm._v("\n            共" + _vm._s(order.productNum) + "个商品 "), _c('span', {
      staticStyle: {
        "margin-left": "1rem"
      }
    }, [_vm._v(" 实支付：")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "1.2rem"
      }
    }, [_vm._v(_vm._s(_vm._f("currencyStyle")(order.totalPrice - order.expressPrice)))])]) : _vm._e(), _vm._v(" "), (order.merchandises[0].categoryId === 10 && order.orderNo) ? _c('span', {
      staticStyle: {
        "font-size": "xx-small",
        "margin-left": "120px"
      }
    }, [_vm._v("订单编号： " + _vm._s(order.orderNo))]) : _vm._e()]), _vm._v(" "), _c('div', [(order.status === 11 && order.merchandises[0].categoryId === 20 && (order.merchandises[0]._attributes.ReguTech === undefined || order.merchandises[0]._attributes.ReguTech.value !== '5')) ? _c('span', {
      staticClass: "orderBtn",
      staticStyle: {
        "color": "#00469A"
      },
      on: {
        "click": function($event) {
          return _vm.buyAgain1(order)
        }
      }
    }, [_vm._v("我要扩增")]) : _vm._e(), _vm._v(" "), ((order.status === 2 || 3) && _vm.button1Name) ? _c('span', {
      staticClass: "orderBtn",
      on: {
        "click": function($event) {
          return _vm.response1(order)
        }
      }
    }, [_c('img', {
      staticClass: "position",
      attrs: {
        "src": _vm.button1Name
      }
    })]) : _vm._e(), _vm._v(" "), (order.researchGroupApproveResult !== _vm.waitApproveStatus && _vm.button2Name) ? _c('span', {
      staticClass: "orderBtn",
      on: {
        "click": function($event) {
          return _vm.response2(order)
        }
      }
    }, [_c('img', {
      staticClass: "pay-btn",
      attrs: {
        "src": _vm.button2Name
      }
    })]) : _vm._e(), _vm._v(" "), (order.isStock === false) ? _c('span', {
      staticClass: "orderBtn",
      staticStyle: {
        "background": "#00469A"
      },
      on: {
        "click": function($event) {
          return _vm.response4(order.priceDetails)
        }
      }
    }, [_vm._v(_vm._s(_vm.button3Name))]) : _vm._e(), _vm._v(" "), (order.audit.comments) ? _c('span', {
      staticClass: "orderBtn",
      staticStyle: {
        "background": "#00469A"
      },
      on: {
        "click": function($event) {
          return _vm.response5(order.audit.comments)
        }
      }
    }, [_vm._v(_vm._s(_vm.button4Name))]) : _vm._e(), _vm._v(" "), (order.sfQuoteStatus === 1) ? _c('span', {
      staticClass: "orderBtn",
      staticStyle: {
        "background": "#00469A"
      },
      on: {
        "click": function($event) {
          return _vm.response6(order.merchandises)
        }
      }
    }, [_vm._v(_vm._s(_vm.button5Name))]) : _vm._e()])]) : _vm._e()])]) : _vm._e()
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c146e3cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MyOrder/order/child/MyOrder.vue
// module id = 1717
// module chunks = 8